module.exports = __webpack_public_path__ + "img/13_l_no.2c1b970e.svg";